import { useStore } from '@nanostores/preact'
import { profile, support } from '../services/store'
import { useTranslation } from './Translation'

import css from '../style.module.scss'
import checkIcon from '../static/icon-check--white.svg'

export const OfferNote = function OfferNote() {
  const t = useTranslation()
  const supportData = useStore(support)
  const user = useStore(profile)

  // Check if support data exists before accessing properties
  if (!supportData) {
    return null // or return a loading state
  }

  const { currencies, products, iso_countries: isoCountries } = supportData

  // Get user's country and currency
  const country = isoCountries.find((c) => c.iso === user.countryIso)
  const currency = currencies.find((c) => c.acronym === country.currency)

  const saveAmount =
    Number(products.monthly.prices[currency.acronym].unit_amount) * 12 -
    Number(products.annually.prices[currency.acronym].unit_amount)

  return (
    <>
      {user.subscription === 'annually' && (
        <p className={css['signup-note']}>
          <img src={checkIcon} alt="checkmark" width={14} />
          {t('save_amount', { amount: currency.prefix + (saveAmount / 100).toFixed(2) })}
        </p>
      )}
      {user.subscription === 'monthly' && (
        <p className={css['signup-note']}>
          <img src={checkIcon} alt="checkmark" width={14} />
          {t('flexible_payments')}
        </p>
      )}
      <p className={css['signup-note']}>
        <img src={checkIcon} alt="checkmark" width={14} />
        {t('easily_cancel_anytime')}
      </p>
    </>
  )
}
